import axios from "axios";
import { DOMAIN_API } from "../constants";


const API_URL = DOMAIN_API + '/api/crud';

export function getModifiedFields<T extends Record<string, any>>(original: T, modified: T): Partial<T> {
	const diff: Partial<T> = {};

	for (const key in modified) {
		if (Object.prototype.hasOwnProperty.call(modified, key)) {
			const originalValue = original[key];
			const modifiedValue = modified[key];

			// Compare values (shallow)
			if (JSON.stringify(originalValue) !== JSON.stringify(modifiedValue)) {
				diff[key] = modifiedValue;
			}
		}
	}
	return diff;
}

export const register = async (data: any) => {
	try {
		const response = await axios.post(API_URL + "/register", data);
		return response.data;
	} catch (error: any) {
		throw new Error('Register failed: ' + error.response.data.message || error.message);
	}
};

export async function queryRegistrars() {
	const response = await axios.get(API_URL + `/registrars`);
	return response.data;
}

export async function updateRegistrar(data: any) {
	const response = await axios.patch(API_URL + '/registrars/', data);
	return response.data;
}

export async function registrarToAlumni(data: any) {
	try {
		const response = await axios.post(API_URL + "/registrars", data);
		return response.data;
	} catch (error: any) {
		throw new Error('registrarToAlumni failed: ' + error.response.data.message || error.message);
	}
};

export async function queryAlumni(id: number, onCheckVersion?: (version: string) => void) {
	const response = await axios.get(API_URL + `/alumni/${id}`);
	console.log("x-version-frontend", response.headers["x-version-frontend"]);
	if (onCheckVersion)
		onCheckVersion(response.headers["x-version-frontend"]);
	return response.data;
}

export async function updateAlumni(id: number, data: any) {
	const response = await axios.patch(API_URL + `/alumni/${id}`, data);
	return response.data;
}

export async function mergeAlumni(id: number, data: any) {
	const response = await axios.post(API_URL + `/alumni/${id}`, data);
	return response.data;
}

export async function queryAlumniList(angkatan: number) {
	const response = await axios.get(API_URL + `/alumnies/${angkatan}`);
	return response.data;
}

export async function queryAlumniRecordStats() {
	const response = await axios.get(API_URL + '/alumnies/0/recstats');
	return response.data;
}

export async function queryNames(filter: string, limit: number = 19) {
	const safeFilter = encodeURIComponent(filter);
	const url = limit ? `${API_URL}/names/${safeFilter}/${limit}` : `${API_URL}/names/${safeFilter}`;
	const response = await axios.get(url);
	return response.data;
}

export async function queryUsers(filter: string) {
	const response = await axios.get(API_URL + `/users/${filter}`);
	return response.data;
}

export async function queryEmail(email: string) {
	const response = await axios.get(API_URL + `/email/${email}`);
	return response.data;
}

